(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product--default"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var sectionIds = [
    'shopify-section-template--25208422269221__main',
    'shopify-section-template--25208422334757__main'
  ];

  sectionIds.forEach(function (id) {
    var root = document.getElementById(id);
    if (!root) return;

    function build() {
      var buttons = root.querySelectorAll('.product__color-swatches .product__color-swatch');
      buttons.forEach(function (btn) {
        if (btn.parentElement && btn.parentElement.classList.contains('swatch-item')) return;
        var wrap = document.createElement('div');
        wrap.className = 'swatch-item';
        btn.parentElement.insertBefore(wrap, btn);
        wrap.appendChild(btn);

        var text = btn.getAttribute('aria-label') || btn.getAttribute('data-option-value') || btn.getAttribute('data-label') || '';
        var span = document.createElement('span');
        span.className = 'swatch-label t-opacity-70';
        span.textContent = text;
        wrap.appendChild(span);
      });
    }

    function updateSelected() {
      root.querySelectorAll('.swatch-label').forEach(function (el) { el.classList.remove('is-selected'); });
      var selBtn = root.querySelector('.product__color-swatch.selected, .product__color-swatch[aria-pressed="true"]');
      if (selBtn) {
        var label = selBtn.parentElement && selBtn.parentElement.querySelector('.swatch-label');
        if (label) label.classList.add('is-selected');
      }
    }

    build();
    updateSelected();

    root.addEventListener('click', function (e) {
      if (!e.target.closest('.product__color-swatch')) return;
      setTimeout(updateSelected, 0);
    });

    var select = root.querySelector('select.dynamic-variant-input');
    if (select) select.addEventListener('change', function () { setTimeout(updateSelected, 0); });

    var observer = new MutationObserver(function () { build(); updateSelected(); });
    observer.observe(root, { childList: true, subtree: true });
  });
});

  } catch(e) { console.error(e); }
})();
})();
